<template>
    <v-app>
        <vue-progress-bar>
        </vue-progress-bar>
        <template v-if="!auth || $route.name === 'Search' || $route.name === 'ViewDocument'  || $route.name === 'PermissionDenied'">
          <keep-alive include="Search">
            <router-view :key="$route.fullPath"></router-view>
          </keep-alive>
        </template>
        <template v-else>
            <v-navigation-drawer permanent="true" class="blue lighten-5" width="250"  light :mini-variant.sync="mini" v-model="drawer" app>
                <!-- mini-variant.sync="true" -->
                <v-list class="pa-0">
                    <v-list-tile avatar tag="div">
                        <v-list-tile-avatar>
                            <v-icon >person</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>Admin <span style="border-bottom: 1px solid black;"><small>v</small>{{this.$version}}</span></v-list-tile-title>
                        </v-list-tile-content>
                        <v-spacer></v-spacer>
                        <v-list-tile-action v-show="1==2" style="min-width:30px;">
                            <v-menu bottom right offset-y origin="bottom right" transition="v-slide-y-transition">
                                <v-btn icon light slot="activator">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile v-for="item in userMenus" :key="item.title" value="true" :to="item.link" router>
                                        <v-list-tile-title v-text="item.title"></v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>

                        </v-list-tile-action>
                        <v-list-tile-action style="min-width:30px;">
                            <v-btn icon @click.native.stop="mini = !mini">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>

                </v-list>

                <v-divider></v-divider>

                <v-list>
                    <v-list-tile v-for="item in items" :key="item.title" @click="clickMenu(item)" router>
                        <v-list-tile-action class="pr-1 pl-2 mr-1">
                            <v-icon :class="activeMenuItem.includes(item.title)?'blue--text': ''" :title="item.title" light v-html="item.icon"></v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content :class="activeMenuItem.includes(item.title)?'blue--text': ''">
                            <v-list-tile-title v-text="item.title"></v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-navigation-drawer>
            <v-toolbar app  v-if="1==2">
                <v-toolbar-side-icon @click.native.stop="drawer = !drawer" light></v-toolbar-side-icon>
                <v-spacer></v-spacer>
                <span class="title">MSBA Document CRM</span>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-content>
                <v-container fluid>
                    <!-- <v-layout>
                      <v-flex row=""> -->
                  <v-alert class="pageAlertBar" v-if="updateResult != null && updateMessage != null"
                           :value="true"
                           dismissible
                           :type="updateResult"
                           transition="scale-transition"
                  >
                    {{ updateMessage}}
                  </v-alert>
                    <router-view :key="$route.fullPath" v-on:alertUser="alertUser"></router-view>
                    <!-- </v-flex>
                  </v-layout> -->
                </v-container>
            </v-content>
            <!-- <canvas id="canvas"></canvas> -->
        </template>
    </v-app>

</template>
<script>
    import { mapState } from "vuex";
    export default {
        data () {
            return {
              showUpdateAlert: true,
              updateMessage: null,
              updateResult: null,
                dialog: false,
                mini: false,
                dialogText: "",
                dialogTitle: "",
                isRootComponent: true,
                // clipped: false,
                drawer: window.innerWidth > 960,
                fixed: false,
                items: [
                    {
                        icon: "dashboard",
                        title: "Dashboard",
                        vertical: "Dashboard",
                        link: {name: 'Dashboard'}
                    },
                    {
                    icon: "text_snippet",
                    title: "Journal Magazines",
                    vertical: "Order",
                    link: {name: 'Documents', params: {type: 'journalarchive'}}
                    },
                    {
                        icon: "leaderboard",
                        title: "Leader Newsletters",
                        vertical: "Order",
                        link: {name: 'Documents', params: {type: 'leaderarchive'}}
                    },
                  {
                    icon: "date_range",
                    title: "Weekly Advocate",
                    vertical: "Order",
                    link: {name: 'Documents', params: {type: 'weeklyadvocatearchive'}}
                  },
                  {
                    icon: "article",
                    title: "eClippings",
                    vertical: "Order",
                    link: {name: 'Documents', params: {type: 'eclippingsarchive'}}
                  },
                    {
                        icon: "library_books",
                        title: "ISD Policies",
                        vertical: "Order",
                        link: {name: 'Documents', params: {type: 'isdpolicy'}}
                    },
                  {
                    icon: "collections_bookmark",
                    title: "Charter Policies",
                    vertical: "Order",
                    link: {name: 'Documents', params: {type: 'charterpolicy'}}
                  },
                  {
                    icon: "list_alt",
                    title: "Resources",
                    vertical: "Order",
                    link: {name: 'Documents', params: {type: 'resource'}}
                  },
                    {
                        icon: "gavel",
                        title: "School Law",
                        vertical: "Customer",
                        link: {name: 'Documents', params: {type: 'servicemanual'}}
                    },
                    {
                        icon: "description",
                        title: "Publications",
                        vertical: "Product",
                        link: {name: 'Documents', params: {type: 'publication'}}
                    },
                  {
                    icon: "menu_book",
                    title: "Law Guide",
                    vertical: "Law Guide",
                    link: {name: 'LawGuideEdit'}
                  },
                  {
                    icon: "timeline",
                    title: "Search Logs",
                    vertical: "Search Logs",
                    link: {name: 'LoggingExport'}
                  },
                    {
                        icon: "search",
                        title: "Search",
                        vertical: "Search",
                        link: {name: 'Search'}
                    },
                 /* {
                    icon: "person",
                    title: "Synced Users",
                    vertical: "SyncedUsers",
                    link: {name: 'SyncedUsers'}
                  },*/

                ],
                userMenus: [
                    {
                        icon: "bubble_chart",
                        title: "Logout",
                        link: "/logout"
                    },
                    {
                        icon: "bubble_chart",
                        title: "Change Password",
                        link: "/changepassword"
                    }
                ],
                miniVariant: false,
                right: true,
                rightDrawer: false,
                menuItem: "Orders"
            };
        },
        created () {
            /* auth.onChange = loggedIn => {
              console.log("loggedIn", loggedIn);
              this.loggedIn = loggedIn;
            }; */
            //  [App.vue specific] When App.vue is first loaded start the progress bar
            this.$Progress.start();
            //  hook the progress bar to start before we move router-view
            this.$router.beforeEach((to, from, next) => {
                //  does the page we want to go to have a meta.progress object
                if (to.meta.progress !== undefined) {
                    let meta = to.meta.progress;
                    // parse meta tags
                    this.$Progress.parseMeta(meta);
// import auth from "./utils/auth";
// import { mapState } from "vuex";
// export default {
//   data () {
//     return {
//       dialog: false,
//       mini: false,
//       dialogText: "",
//       dialogTitle: "",
//       loggedIn: auth.loggedIn(),
//       // isRootComponent: true,
//       // clipped: false,
//       drawer: false,
//       fixed: false,
//       items: [
//         {
//           icon: "dashboard",
//           title: "Dashboard",
//           vertical: "Dashboard",
//           link: "dashboard"
//         },
//         {
//           icon: "shopping_cart",
//           title: "Orders",
//           vertical: "Order",
//           link: "orders"
//         },
//         {
//           icon: "perm_identity",
//           title: "Customers",
//           vertical: "Customer",
//           link: "customers"
//         },
//         {
//           icon: "bubble_chart",
//           title: "Products",
//           vertical: "Product",
//           link: "products"
//         },
//         {
//           icon: "thumbs_up_down",
//           title: "About",
//           vertical: "About",
//           link: "about"
                }
                //  start the progress bar
                this.$Progress.start();
                //  continue to next page
                next();
            });
            //  hook the progress bar to finish after we've finished moving router-view
            this.$router.afterEach((to, from) => {
                if (to.name !== "ErrorPage") {
                    this.menuItem = to.name;
                }
                //  finish the progress bar
                this.$Progress.finish();
            });
        },
        computed: {
            auth() {
              return true
                if (this.$userData.token !== undefined) {
                    console.log('returning true')
                    return true
                } else {
                    return false
                }

            },
            activeMenuItem() {
                return this.menuItem;
            }
        },
        methods: {
          alertUser(result, message, closeTimeout = 2000) {
            console.log('alert user called', result, message)
            this.showUpdateAlert = false;
            this.updateMessage = null
            this.updateResult = null
            setTimeout(() => {
              this.updateMessage = message
              this.updateResult = result
              if(result =="error" && message === undefined) {
                this.updateMessage = "Sorry, there was an error processing your request. Please try again later."
              }
              this.showUpdateAlert = true;
            }, 1)

            if(result != "error" && result != 'warning') {
              setTimeout(() => {
                this.showUpdateAlert = false;
                this.updateMessage = null
                this.updateResult = null
              }, closeTimeout)
            }



          },
            clickMenu(item) {
                this.menuItem = item.title;
                this.$router.push(item.link);
            },
        },
        mounted () {
            this.$Progress.finish();
        }
    };
</script>
<style lang="stylus">
    @import './stylus/main';
    .v-navigation-drawer .v-list >div:nth-child(1),
    .v-navigation-drawer .v-list >div:nth-child(5),
    .v-navigation-drawer .v-list >div:nth-child(9),
    .v-navigation-drawer .v-list >div:nth-child(11)
    {border-bottom: 1px solid #00000026;}
    .lableTitle {
        font-weight: 700;
        color: grey;
        vertical-align: super;
    }
    .theme--light.application {
      background white !important;
    }

    .pageAlertBar {
      font-size: 20px;
      color: black;
      font-weight: 900;
      margin-top: 0;
      margin-bottom: 0;
      position: sticky;
      top: 0;
      z-index: 7;
    }
</style>
